import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EntryCyclesView } from '../../../_generated';

export const EntryCyclesActions = createActionGroup({
  source: 'EntryCycles',
  events: {
    Load: emptyProps(),
    Get: props<{ entryCycles: EntryCyclesView[] }>(),
    Reset: emptyProps(),
  },
});
